import React from 'react';

/**
 * A reusable label component that accepts children, styled with Tailwind CSS.
 *
 * @param {object} props - The props object.
 * @param {React.ReactNode} props.children - The children to be rendered inside the label.
 * @param {string} [props.forId] - The ID of the form element this label is associated with.
 * @param {string} [props.className] - Additional custom class names for more specific styling.
 * 
 * @category Components - UI
 */
function Label({ children, forId, className = '' }) {
    return (
        <label htmlFor={forId} className={`block text-sm font-semibold text-gray-700 mb-1 ${className}`}>
            {children}
        </label>
    );
}

export default Label;
